
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 512 448","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m464 0h-416c-26.51 0-48 21.49-48 48v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48v-352c0-26.51-21.49-48-48-48zm-304 416h-112c-8.837 0-16-7.163-16-16v-80h128zm0-128h-128v-96h128zm0-128h-128v-96h128zm160 256h-128v-96h128zm0-128h-128v-96h128zm0-128h-128v-96h128zm160 160v80c0 8.837-7.163 16-16 16h-112v-96zm0-32h-128v-96h128zm0-128h-128v-96h128z","fill":"#000"}})])
          )
        }
      }
    